import { useLocale } from "@react-aria/i18n";
import { Bell, CalendarDays, Clock4, User } from "lucide-react";

export function LeftPanel({
	showForm,
	timeZone,
	slot
}: {
	showForm: boolean | null;
	timeZone: string;
	slot?: string;
}) {
	const { locale } = useLocale();

	return (
		<div className="flex flex-col flex-1 w-full lg:px-6 px-4 lg:py-8 py-4 border-r ">
			<div className="grid">
				<h1 className="text-xl font-medium mb-4">Weight loss consultation</h1>
				{showForm && (
					<div className="flex flex-col gap-2 space-y-4">
						<div className="flex items-center">
							<User className="size-5 mr-2 text-[#7F8493]" />
							<p className="text-base font-medium text-[#26282F]">
								Maurice Umoh
							</p>
						</div>
						<div className="flex items-center">
							<CalendarDays className="size-5 mr-2 text-[#7F8493]" />
							<p className=" text-base font-medium text-[#26282F]">
								Wednesday Mar 26, 2025
							</p>
						</div>
						<div className="flex items-center ">
							<Bell className="size-5 mr-2 text-[#7F8493]" />
							<p className=" text-base font-medium text-[#26282F]">
								{new Date(slot as string).toLocaleString(locale, {
									hour: '2-digit',
									minute: '2-digit',
									hour12: true
								})}
								{", "}
								{timeZone.replace(/_/g, " ").split("(")[0]?.trim()}
							</p>
						</div>
					</div>
				)}
				<div className="flex items-center mt-5">
					<Clock4 className="size-5 mr-2 text-[#7F8493]" />
					<p className="text-base font-medium text-[#26282F]">15 mins</p>
				</div>
			</div>
			<div className="mt-8">
				<h2 className="text-lg font-medium mb-4">Previous appointments</h2>
				<div className="flex flex-col gap-2 space-y-4">
					<div className="flex items-center">
						<User className="size-5 mr-2 text-[#7F8493]" />
						<p className="text-base font-medium text-[#26282F] line-through">
							Maurice Umoh
						</p>
					</div>
					<div className="flex items-center">
						<CalendarDays className="size-5 mr-2 text-[#7F8493]" />
						<p className="text-base font-medium text-[#26282F] line-through">
							Wednesday Mar 20, 2025
						</p>
					</div>
					<div className="flex items-center">
						<Bell className="size-5 mr-2 text-[#7F8493]" />
						<p className="text-base font-medium text-[#26282F] line-through">
							12:00 PM, America/New_York
						</p>
					</div>
					<div className="flex items-center">
						<Clock4 className="size-5 mr-2 text-[#7F8493]" />
						<p className="text-base font-medium text-[#26282F] line-through">
							15 mins
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
